const primaryMain = '#232D4B';
const primaryMainOpacity = 'rgba(35,45,75,0.9)';
const secondaryMain = '#E57200';
const secondaryMainOpacity = 'rgba(229, 114, 0, 0.5)';
const secondaryLight = '#1f6d50';
const tertiaryMain = '#E57200';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
